module.exports = __webpack_public_path__ + "static/step2-element-e6f28e3c6a6e3302a78ae0d073ba09b5.png";